import { genCompetitionRanking } from '../../../utils';
import TopTen from '../../Challenge/UserRanking/TopTen';


// Finished -> podium
const CompetitionStage4 = ({ lang, theCompetition }) => {
    const ranking = genCompetitionRanking(theCompetition.responses, theCompetition.participants);

    // console.log('CompetitionStage4 ranking:', ranking);
    const sound = './static/sounds/super-hero.mp3';

    return <section className="competition-finished">
        {sound ? <audio src={sound} autoPlay={true} loop={false}></audio> : null}

        <TopTen lang={lang} top10={ranking} title='podium' animate={true} />
    </section>;
}

export default CompetitionStage4;